/**
 * fonts.ts — Carregamento determinístico via @remotion/google-fonts
 *
 * ANTES: loadGoogleFont() injetava <link> CDN em runtime — instável,
 *        FOUT no frame 1, falha se DNS flutuar.
 *
 * AGORA: loadFont() é chamado no nível de módulo. @remotion/google-fonts
 *        chama delayRender() automaticamente e só libera o render quando
 *        a fonte está pronta. Determinístico em todos os environments.
 */

// ─── @remotion/google-fonts — carregamento estável ───────────────────
import {loadFont as loadInter}          from "@remotion/google-fonts/Inter";
import {loadFont as loadPoppins}        from "@remotion/google-fonts/Poppins";
import {loadFont as loadPlayfair}       from "@remotion/google-fonts/PlayfairDisplay";
import {loadFont as loadJetBrains}      from "@remotion/google-fonts/JetBrainsMono";

// Carregamento no nível de módulo — delayRender() é chamado automaticamente.
// Componentes que importam fonts.ts já disparam o carregamento.
const _inter     = loadInter("normal",   {weights: ["400","500","600","700","800","900"]});
const _poppins   = loadPoppins("normal", {weights: ["400","500","600","700","800","900"]});
const _playfair  = loadPlayfair("normal",{weights: ["400","500","600","700","800","900"]});
const _jetbrains = loadJetBrains("normal",{weights: ["400","500","700"]});

// Font family strings retornados pelo package (incluem fallbacks seguros)
export const FONT_FAMILIES = {
  heading:  _inter.fontFamily,
  body:     _inter.fontFamily,
  mono:     _jetbrains.fontFamily,
  display:  _poppins.fontFamily,
  elegant:  _playfair.fontFamily,
} as const;

export type FontFamilyKey = keyof typeof FONT_FAMILIES;

/** DIN Alternate — não disponível no @remotion/google-fonts, mantido como fallback */
export const DIN_FONT_STACK = "'DIN Alternate', 'Inter', sans-serif";

/** Font stack para Café com teu ROI — Inter principal */
export const CAFE_FONT_STACK = `${_inter.fontFamily}, 'SF Pro Display', sans-serif`;

/**
 * loadDefaultFonts() — backward compat.
 * As fontes já são carregadas no nível de módulo ao importar este arquivo.
 * Esta função é um no-op mantido para não quebrar imports existentes.
 */
export const loadDefaultFonts = (): void => {
  // No-op: carregamento acontece via module-level loadFont() acima.
  // delayRender() é gerenciado automaticamente pelo @remotion/google-fonts.
};

/**
 * @deprecated Usar FONT_FAMILIES.heading, FONT_FAMILIES.display, etc.
 * Mantido para backward compat com componentes que usam loadGoogleFont diretamente.
 */
export const loadGoogleFont = (_fontFamily: string, _weights?: string): void => {
  // No-op: substituído pelo carregamento determinístico acima.
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
